import React from "react";
import "./App.css";
import SSOLogin from "./components/SSOLogin";

function App() {

  return (
    <div className="App">
      <SSOLogin />
    </div>
  );
}

export default App;
